import { DeliveryLayout } from "@features/layout/delivery";

export const DeliveryPage = () => {
  return <DeliveryLayout />;
};
